const state = {
  initial: null,
  isLogin: null,
  isLoading: [],
  isDialogLoading: [],
  isUploading: [],
  modal: {
    action: null,
    param: null,
    callback: null,
    height: null,
    width: null,
    closeButton: true,
    customStyles: {}
  },
  messages: [],
  // const
  normalPage: [
    'main',
    'payment',
    'introduction',
    'index'
  ],
  userPage: [
  ],
  adminPage: [
  ]
}

const getters = {
  initial: state => state.initial,
  isLogin: state => state.isLogin,
  isLoading: state => state.isLoading.length > 0,
  isDialogLoading: state => state.isDialogLoading.length > 0,
  isUploading: state => state.isUploading.length > 0,
  modal: state => state.modal,
  messages: state => state.messages,
  // const
  normalPage: state => state.normalPage,
  userPage: state => state.userPage,
  adminPage: state => state.adminPage
}

const types = {
  appInitial: 'app/appInitial',
  setLogin: 'app/setLogin',
  setLoading: 'app/setLoading',
  clearLoading: 'app/clearLoading',
  setDialogLoading: 'app/setDialogLoading',
  clearDialogLoading: 'app/clearDialogLoading',
  setUploading: 'app/setUploading',
  setModal: 'app/setModal',
  addToast: 'app/addToast',
  deleteToast: 'app/deleteToast'
}

const mutations = {
  [types.appInitial] (state, boolean) {
    state.initial = boolean
  },
  [types.setLogin] (state, boolean) {
    state.isLogin = boolean
  },
  [types.setLoading] (state, boolean) {
    if (boolean !== undefined) {
      if (boolean) {
        state.isLoading.push('')
      } else {
        state.isLoading.pop()
      }
    }
  },
  [types.clearLoading] (state) {
    state.isLoading = []
  },
  [types.setDialogLoading] (state, boolean) {
    if (boolean !== undefined) {
      if (boolean) {
        state.isDialogLoading.push('')
      } else {
        state.isDialogLoading.pop()
      }
    }
  },
  [types.clearDialogLoading] (state) {
    state.isDialogLoading = []
  },
  [types.setUploading] (state, boolean) {
    if (boolean !== undefined) {
      if (boolean) {
        state.isUploading.push('')
      } else {
        state.isUploading.pop()
      }
    }
  },
  [types.setModal] (state, object) {
    state.modal = object
  },
  [types.addToast] (state, object) {
    state.messages.push(object)
    setTimeout(function () {
      state.messages.splice(0, 1)
    }, 5000)
  },
  [types.deleteToast] (state, index) {
    state.messages.splice(index, 1)
  }
}

const actions = {
  appInitialAction ({commit}, boolean) {
    commit(types.appInitial, boolean)
  },
  setLoginAction ({commit}, boolean) {
    commit(types.setLogin, boolean)
  },
  setLoadingAction ({commit}, boolean) {
    commit(types.setLoading, boolean)
  },
  clearLoadingAction ({commit}) {
    commit(types.clearLoading)
  },
  setDialogLoadingAction ({commit}, boolean) {
    commit(types.setDialogLoading, boolean)
  },
  clearDialogLoadingAction ({commit}) {
    commit(types.clearDialogLoading)
  },
  setUploadingAction ({commit}, boolean) {
    commit(types.setUploading, boolean)
  },
  setModalAction ({commit}, string) {
    commit(types.setModal, string)
  },
  addToastAction ({commit}, object) {
    commit(types.addToast, object)
  },
  deleteToastAction ({commit}, index) {
    commit(types.deleteToast, index)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js